import { render, staticRenderFns } from "./total-add.vue?vue&type=template&id=f4302686"
import script from "./total-add.vue?vue&type=script&lang=js"
export * from "./total-add.vue?vue&type=script&lang=js"
import style0 from "./total-add.vue?vue&type=style&index=0&id=f4302686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports